module.exports = __webpack_public_path__ + "img/环境优雅@2x.5feea161.png";